import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _modalVariants;

import { ConfirmModal, ErrorModal, InfoModal } from '@modals';
import { Modals } from '@enums';
export var modalVariants = (_modalVariants = {}, _defineProperty(_modalVariants, Modals.Info, InfoModal), _defineProperty(_modalVariants, Modals.Confirm, ConfirmModal), _defineProperty(_modalVariants, Modals.Error, ErrorModal), _modalVariants);